export const CHECKOUT_CONTACT_FETCHING = 'CHECKOUT_CONTACT_FETCHING'
export const CHECKOUT_CONTACT_SUCCESS = 'CHECKOUT_CONTACT_SUCCESS '
export const CHECKOUT_CONTACT_FAILURE = 'CHECKOUT_CONTACT_FAILURE'
